export default "__VITE_ASSET__B35$vCWx__"